import {useEffect, useState} from "react";
import {newsDetail} from "../api/api";
import HomeTopbar from "../homepage/components/HomeTopbar";
import commonBtnBack from "../assets/images/commonbtn/common_btn_back.png";
import commonBtnBack2x from "../assets/images/commonbtn/common_btn_back@2x.png";
import commonBtnBackHover from "../assets/images/commonbtn/common_btn_back_hover.png";
import commonBtnBackHover2x from "../assets/images/commonbtn/common_btn_back_hover@2x.png";
import "../homepage/HomePage.css";

function renderContentBlock(block, index) {
    if (block.type === "heading") return <h3 key={index}>{block.text}</h3>;
    if (block.type === "subheading") return <h4 key={index}>{block.text}</h4>;
    return <p key={index}>{block.text}</p>;
}

function formatNewsDate(value) {
    const match = String(value || "").match(/^(\d{4})-(\d{2})-(\d{2})/);
    return match ? `${match[1]}.${match[2]}.${match[3]}` : value;
}

export default function NewsDetailPage({id, isMusicOn, onMusicToggle}) {
    const [news, setNews] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        let alive = true;

        async function loadNewsDetail() {
            setIsLoading(true);
            const response = await newsDetail({id});
            const result = response && response.data;

            if (alive) {
                if (result && result.code === 0 && result.data && result.data.id) {
                    setNews(result.data);
                } else {
                    setNews(null);
                }
                setIsLoading(false);
            }
        }

        loadNewsDetail();

        return () => {
            alive = false;
        };
    }, [id]);

    return (
        <div className="wraps news-detail-page news_bg">
            <HomeTopbar activeNavId="news" isMusicOn={isMusicOn} onMusicToggle={onMusicToggle} reserveHref="#home" />
            <main className="news-detail-main">
                <section className="news-detail-shell" aria-label="公告详情">
                  
                    <div className="news_container">
                        <div className="news_container_topbar">                          
                            <a className="news-back" href="#news" aria-label="返回新闻列表">
                                <picture>
                                    <source media="(min-width: 1921px)" srcSet={commonBtnBack2x}/>
                                    <img className="default" src={commonBtnBack} alt="" aria-hidden="true"/>
                                </picture>
                                <picture>
                                    <source media="(min-width: 1921px)" srcSet={commonBtnBackHover2x}/>
                                    <img className="active" src={commonBtnBackHover} alt="" aria-hidden="true"/>
                                </picture>
                            </a>
                        </div>

                        {isLoading ? (
                            <article className="news_detail_cont news-empty-state">
                                <h1 className="news_detail_cont_tit">新闻加载中...</h1>
                            </article>
                        ) : news ? (
                            <article className="news_detail_cont">
                                <header className="news-detail-heading">
                                    <div className="news-detail-title-group">
                                        <span className="news-detail-category">{news.category || "公告"}</span>
                                        <h1 className="news_detail_cont_tit">{news.title}</h1>
                                    </div>
                                    <div className="news_detail_cont_time">
                                        <span>失乐枷锁制作组</span>
                                        <time dateTime={news.datetime}>{formatNewsDate(news.datetime)}</time>
                                    </div>
                                </header>
                                <div className="sContent">
                                    {(news.content || []).map(renderContentBlock)}
                                </div>
                            </article>
                        ) : (
                            <article className="news_detail_cont news-empty-state">
                                <h1 className="news_detail_cont_tit">新闻不存在或已下线</h1>
                                <div className="sContent">
                                    <p>请返回首页重新选择新闻内容。</p>
                                    <p><a href="#news">返回首页新闻公告</a></p>
                                </div>
                            </article>
                        )}
                    </div>
                </section>
            </main>
        </div>
    );
}
